import Swal from 'sweetalert2';

interface AuditExportPanelProps {
  totalEntries: number;
  filteredEntries: number;
  hasFilters: boolean;
}

function showExportAlert(format: string, count: number) {
  const iconMap: Record<string, string> = {
    CSV: 'ri-file-excel-2-line',
    Excel: 'ri-file-excel-2-line',
    PDF: 'ri-file-pdf-2-line',
  };

  Swal.fire({
    icon: 'success',
    title: `${format} Exportado`,
    html: `
      <div class="text-center">
        <p class="text-sm text-gray-500 mt-1">${count} registros exportados a audit-log.${format.toLowerCase()} (simulación)</p>
        <p class="text-xs text-gray-400 mt-2">En producción, este archivo se descargará automáticamente.</p>
      </div>
    `,
    confirmButtonColor: '#1a1a1a',
    customClass: {
      popup: 'rounded-2xl text-sm',
      title: 'text-sm font-bold',
      confirmButton: 'text-xs font-medium px-4 py-2 rounded-xl',
    },
  });
}

export default function AuditExportPanel({ totalEntries, filteredEntries, hasFilters }: AuditExportPanelProps) {
  if (totalEntries === 0) return null;

  const count = filteredEntries;

  const handleExport = (format: string) => {
    if (count === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Sin datos',
        text: 'No hay registros para exportar con los filtros actuales.',
        confirmButtonColor: '#1a1a1a',
        customClass: {
          popup: 'rounded-2xl text-sm',
          title: 'text-sm font-bold',
          confirmButton: 'text-xs font-medium px-4 py-2 rounded-xl',
        },
      });
      return;
    }
    showExportAlert(format, count);
  };

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-0.5 bg-background-50 border border-background-200 rounded-xl overflow-hidden">
        <button
          onClick={() => handleExport('CSV')}
          className="flex items-center gap-1.5 px-3 py-2 text-foreground-600 text-xs font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap border-r border-background-200"
          title="Exportar como CSV"
        >
          <i className="ri-file-text-line text-sm"></i>
          <span className="hidden sm:inline">CSV</span>
        </button>
        <button
          onClick={() => handleExport('Excel')}
          className="flex items-center gap-1.5 px-3 py-2 text-foreground-600 text-xs font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap border-r border-background-200"
          title="Exportar como Excel"
        >
          <i className="ri-file-excel-2-line text-sm"></i>
          <span className="hidden sm:inline">Excel</span>
        </button>
        <button
          onClick={() => handleExport('PDF')}
          className="flex items-center gap-1.5 px-3 py-2 text-foreground-600 text-xs font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          title="Exportar como PDF"
        >
          <i className="ri-file-pdf-2-line text-sm"></i>
          <span className="hidden sm:inline">PDF</span>
        </button>
      </div>

      {hasFilters && (
        <span className="text-foreground-400 text-[10px] hidden sm:inline">
          {filteredEntries} de {totalEntries} registros
        </span>
      )}
    </div>
  );
}